// extracted by mini-css-extract-plugin
module.exports = {"reminderWrapper":"CheckReminder_reminderWrapper__2nCSE","textContainer":"CheckReminder_textContainer__3dhEq","icon":"CheckReminder_icon__2OCAr"};